import { Button } from "@primitives/button";
import { useNewGroupChatState } from "@/zustand/NewGroupChatState";
import { ChevronLeft } from "lucide-react";

type Props = {
  disabled?: boolean;
};

export default function FirstStepButton({ disabled }: Props) {
  // state actions
  const setStep = useNewGroupChatState((state) => state.setStep);

  return (
    <Button
      disabled={disabled}
      className="mr-2"
      size="icon"
      variant="ghost"
      onClick={() => setStep(1)}
    >
      <ChevronLeft />
    </Button>
  );
}
